import { __decorate } from "tslib";
import { mixins } from 'vue-class-component';
import { Component } from 'vue-property-decorator';
import AlertMixin from '@/helpers/vue_mixins/AlertMixin';
import DiyMixin from '@/helpers/vue_mixins/v2/DiyMixin';
import ShippingMethodUpdate from '@/plugins/graphql/mutations/v2/shipping-method-update.gql';
import ShippingFragment from '@/plugins/graphql/fragments/v2/shipping-method.gql';
import { Mutation } from 'vuex-class';
import { successfulUpdate } from '@/helpers/mixins/LocalizationHelper';
import CleverTapEventsMixin from '@/helpers/vue_mixins/v3/CleverTapEventsMixin';
let ShippingUpdateMixin = class ShippingUpdateMixin extends mixins(AlertMixin, DiyMixin, CleverTapEventsMixin) {
    constructor() {
        super(...arguments);
        this.shippingMethod = null;
    }
    get formData() {
        const { shippingMethod } = this;
        const data = {
            name: null,
            description: null,
            fee: null,
            customerInitiated: false,
        };
        if (shippingMethod) {
            const { name, description, price, customerInitiated } = shippingMethod;
            return {
                name,
                description,
                fee: price,
                customerInitiated,
            };
        }
        return data;
    }
    goToShippingsPage() {
        this.$router.push({ name: 'ecommerce-shipping' });
    }
    async onSubmit(form, uuid) {
        this.mutationRequestOnFlight();
        await this.update(form, uuid)
            .then(() => {
            if (!this.diy) {
                this.shippingManagerAction('SUBMIT EDIT');
                const msg = successfulUpdate('Shipping');
                this.successNotification(msg);
                this.goToShippingsPage();
            }
            this.onNext();
        })
            .catch((e) => {
            this.errorNotification(e.message);
        })
            .finally(() => {
            this.requestDone();
        });
    }
    async update(form, uuid) {
        this.$apollo.mutate({
            mutation: ShippingMethodUpdate,
            variables: {
                input: {
                    name: form.name,
                    description: form.description,
                    price: form.fee,
                    customerInitiated: form.customerInitiated,
                    shippingMethodUuid: uuid,
                },
            },
            update(cache, result) {
                const { data: { shippingMethodUpdate: { shippingMethod }, }, } = result;
                cache.writeFragment({
                    id: shippingMethod.uuid,
                    fragment: ShippingFragment,
                    data: shippingMethod,
                    fragmentName: 'ShippingMethod',
                });
            },
        });
    }
};
__decorate([
    Mutation('requestOnFlight')
], ShippingUpdateMixin.prototype, "mutationRequestOnFlight", void 0);
__decorate([
    Mutation('requestDone')
], ShippingUpdateMixin.prototype, "requestDone", void 0);
ShippingUpdateMixin = __decorate([
    Component
], ShippingUpdateMixin);
export default ShippingUpdateMixin;
